/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Unlockaccess_Unlockaccesscolumnheader5Inputs */

const en_coinvestments_outreach_unlockaccess_unlockaccesscolumnheader5 = /** @type {(inputs: Coinvestments_Outreach_Unlockaccess_Unlockaccesscolumnheader5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock access`)
};

/**
* | output |
* | --- |
* | "Unlock access" |
*
* @param {Coinvestments_Outreach_Unlockaccess_Unlockaccesscolumnheader5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_unlockaccess_unlockaccesscolumnheader5 = /** @type {((inputs?: Coinvestments_Outreach_Unlockaccess_Unlockaccesscolumnheader5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Unlockaccess_Unlockaccesscolumnheader5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_unlockaccess_unlockaccesscolumnheader5(inputs)
});
export { coinvestments_outreach_unlockaccess_unlockaccesscolumnheader5 as "coInvestments_outreach_unlockAccess_unlockAccessColumnHeader" }